//css
import {
  HomeContainer,
  HeaderMisenscene,
  AboutMisenscene,
  BtnPortfolio,
} from "./styles";
import { ParagraphPatern, TitleSectionsPatern } from "../../App";

//components
import Contacts from "../../components/Contacts";
import photo1 from "../../images/photo1.png";
import photo2 from "../../images/photo2.png";
import photo3 from "../../images/photo3.png";
import photo4 from "../../images/photo4.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import { useFetchDocument } from "../../hooks/useFetchDocument";
import Loading from "../../components/Loading";

const enviroment = process.env.REACT_APP_ENVIROMENT;

const Home = () => {
  const [aboutMisenscene, setAboutMisenscene] = useState("");

  const { document, loading, error } = useFetchDocument(
    enviroment === "prod" ? "config" : "config-test",
    "config",
  );

  useEffect(() => {
    if (document && !loading && !error) {
      setAboutMisenscene(document.sobre_nos);
    }
  }, [document, loading, error]);

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    draggable: false,
    responsive: [
      {
        breakpoint: 920,
        setting: {
          dots: true,
          arrow: false,
        },
      },
    ],
  };
  return (
    <>
      {loading && (
        <>
          <Loading />
        </>
      )}
      {document && !loading && !error && (
        <HomeContainer>
          <HeaderMisenscene>
            <Slider {...settings}>
              <img src={photo1} alt="photo1" />
              <img src={photo2} alt="photo2" />
              <img src={photo3} alt="photo3" />
              <img src={photo4} alt="photo4" />
            </Slider>
          </HeaderMisenscene>
          <AboutMisenscene>
            <TitleSectionsPatern>Sobre a Misenscene</TitleSectionsPatern>
            <ParagraphPatern>{aboutMisenscene}</ParagraphPatern>
            <BtnPortfolio
              href="/assets/PortfolioMisenscene.pdf#toolbar=0&navpanes=0&scrollbar=0"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ver-portfolio"
            >
              Ver Portfólio Misenscene
            </BtnPortfolio>
          </AboutMisenscene>
          <Contacts subject={"A Misenscene"} />
        </HomeContainer>
      )}
    </>
  );
};

export default Home;
